export default __webpack_public_path__ + "static/media/uniLogin.dbc1dd32.png";